export function guestBase(slug) {
  return slug ? `/r/${slug}` : "";
}

export function guestHref(slug, path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return slug ? `/r/${slug}${p}` : p;
}

export function guestApi(slug, path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return slug ? `/r/${slug}${p}` : p;
}
